namespace TabAurous.OMS {
    export namespace ProcessInspectionService {
        export const baseUrl = 'OMS/ProcessInspection';

        export declare function Create(request: Serenity.SaveRequest<ProcessInspectionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProcessInspectionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProcessInspectionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProcessInspectionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProcessQCList(request: QCRequest, onSuccess?: (response: Serenity.ListResponse<ProcessInspectionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/ProcessInspection/Create",
            Update = "OMS/ProcessInspection/Update",
            Delete = "OMS/ProcessInspection/Delete",
            Retrieve = "OMS/ProcessInspection/Retrieve",
            List = "OMS/ProcessInspection/List",
            GetProcessQCList = "OMS/ProcessInspection/GetProcessQCList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetProcessQCList'
        ].forEach(x => {
            (<any>ProcessInspectionService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
